module.exports = __webpack_public_path__ + "static/async-follower-7f678dbbb51ceef8578af3ec5310d14e.png";